import { object, string } from "yup";

export type DealTodo = {
	completed: boolean;
	completedAt: string | null;
	dueDate: string | null;
	id: number;
	memo: string | null;
	staff: {
		id: number;
		name: string;
	} | null;
	title: string;
	todoTemplateId: number | null;
};

export const STATUS_OPTIONS = [
	{ label: "未完了", value: "false" },
	{ label: "完了", value: "true" },
	{ label: "すべて", value: "all" }
] as const satisfies { label: string; value: string }[];

export type DealTodoEdit = Omit<DealTodo, "id" | "completedAt">;
export const buildInitialDealTodoEdit = (): DealTodoEdit => ({
	completed: false,
	dueDate: null,
	memo: "",
	staff: null,
	title: "",
	todoTemplateId: null
});

export const validationSchema = object().shape({
	title: string().required("入力してください")
});
